<template>
  <div id="topBar" class="columns is-flex is-justify-content-center">
      <img
        id="logo-econtador"
        alt="eContador"
        :src="logoSrc"
      />
  </div>
</template>
<script>
export default {
  name: "TrfTopBar",
  computed: {
    logoSrc() {
      return getComputedStyle(document.documentElement).getPropertyValue('--logoUrl').trim();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
#topBar {
  background-color: var(--primaryColor, $primary);
  font-size: 14px;
  text-decoration: none solid rgba(51, 51, 51);
  color: #ffffff;
  height: 62px;
  padding: 0 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  margin: 0;
  z-index: 101;
}

</style>
